<template>
  <!-- container only show when below conditions are full fill -->
  <div :style="{ width: videoChatWidth + '%' }" id="video-display-container" :class="{ 'screen-sharing': screenSharingOn }" v-if="(this.apiKey != '' && this.sessionId != '' && this.token != '') || showPlayBackComponent">
    <div id="video-chat-container" :class="{ 'screen-sharing': screenSharingOn }" v-if="this.apiKey != '' && this.sessionId != '' && this.token != '' && isTHCallOnGoing">
      <Session :recordingOptions="recordingOptions" :callObject="callObject" :sessionId="sessionId" :apiKey="apiKey" :token="token" :tokensNKeys="tokenResponse"></Session>
    </div>
    <div class="full-width">
      <PlaybackThCall v-if="showPlayBackComponent" :fullScreen="fullScreenWidth" :videoObj="videoObj" :archiveOptions="archiveOptions" @switchScreen="switchScreen"></PlaybackThCall>
    </div>
  </div>
</template>

<script>
import toastr from "toastr";
import Session from "./Session.vue";
import PlaybackThCall from "./PlaybackThCall.vue";
import { mapGetters } from "vuex";

export default {
  name: "videoChat",
  data() {
    return {
      sessionId: "",
      apiKey: "",
      token: "",
      tokenResponse: "",
      isTHCallOnGoing: false,
      showPlayBackComponent: false,
      hideTHContainer: false,
      videoChatWidth: 26,
      videoObj: null,
      fullScreenWidth: "fullScreen",
      archiveOptions: null,
      screenSharingOn: false,
      callObject: null,
      recordingOptions: {},
      dataObj: {},
      queryParams: {}
    };
  },
  created() {},
  components: { Session, PlaybackThCall },
  computed: { ...mapGetters(["user"]) },
  mounted() {
    const that = this;
    that.$root.$on("videoCallingInitiated", callObj => {
      this.callObject = callObj;
      that.$root.telehealthStarted = true;
      this.isTHCallOnGoing = true;
      let startTimeMillisec = 0;
      let offset = 0;
      if (callObj.startTime) {
        const startTimeObj = new Date(callObj.startTime);
        offset = startTimeObj.getTimezoneOffset() * -60000;
        startTimeMillisec = callObj.startTime;
      } else {
        const currentDateObj = new Date();
        offset = currentDateObj.getTimezoneOffset() * -60000;
        startTimeMillisec = currentDateObj.getTime();
      }

      let siteId = "";
      if (this.user.userRole == "Interviewer") {
        siteId = localStorage.getItem("selectedSite").toString();
      } else {
        siteId = this.user.siteIds ? this.user.siteIds[0] : null;
      }
      this.dataObj = {
        studyId: callObj.studyId,
        participantId: callObj.threadID ? callObj.threadID : callObj.participantId,
        siteId: siteId,
        startTime: startTimeMillisec,
        endTime: null,
        completionWindow: 0,
        visitType: callObj.type ? callObj.type : "Unscheduled",
        visitId: callObj.visitId ? callObj.visitId : null,
        siteTeamMembersInvites: callObj.selectedTeamMembers
      };

      this.queryParams = {
        pid: this.user.id,
        offset: offset,
        appointmentId: callObj.id ? callObj.id : null
      };
      if (callObj.deviceRegistrationStatus != undefined) {
        this.queryParams.deviceRegistrationStatus = callObj.deviceRegistrationStatus;
      }
      if (callObj.type != undefined && callObj.type == "scheduled") {
        that.getParticipantCountryId();
      } else {
        that.getCountrySpecificStudyFeatures(callObj.countryId);
      }
    });
    //Look for the end call event initiated from the PI
    this.$root.$on("videoCallEnded", () => {
      this.apiKey = "";
      this.sessionId = "";
      this.token = "";
      this.$root.telehealthStarted = false;
      this.isTHCallOnGoing = false;
      this.screenSharingOn = false;
    });
    this.$root.$on("playBackVideoStarted", data => {
      this.isTHCallOnGoing = false;
      this.showPlayBackComponent = true;
      this.videoChatWidth = 100;
      this.fullScreenWidth = "fullScreen";
      this.videoObj = null;
      this.archiveOptions = data;
    });
    this.$root.$on("playBackVideoEnded", () => {
      this.showPlayBackComponent = false;
    });
    // hide the side panel if screen sharing is enabled
    this.$root.$on("screenSharingStarted", () => {
      this.hideTHContainer = true;
      this.videoChatWidth = 100;
      this.screenSharingOn = true;
    });
    this.$root.$on("screenSharingEnded", () => {
      this.hideTHContainer = false;
      this.videoChatWidth = 26;
      this.screenSharingOn = false;
    });

    this.$root.$on("videoCallingInitiated", () => {
      this.videoChatWidth = 26;
    });

    this.$root.$on("fullScreen", value => {
      if (value) {
        this.videoChatWidth = 100;
      } else {
        this.videoChatWidth = 26;
      }
    });
  },
  methods: {
    createSession() {
      this.queryParams.deviceRegistrationStatus = true;
      this.$api.getVideoCallSession(this.queryParams, this.dataObj).then(
        response => {
          const responseObj = response.body;
          this.tokenResponse = responseObj;
          this.apiKey = responseObj.apiKey;
          this.sessionId = responseObj.sessionId;
          this.token = responseObj.token;
          window.localStorage.setItem("thread-currentCallId", responseObj.appointmentId);

          //add appointment to tokenResponse to bifurcate between the schedule and unschedule call
          this.tokenResponse.appointmentType = this.callObject.type ? this.callObject.type : "Unscheduled";
        },
        error => {
          this.$root.$emit("videoCallEnded");
          if (error.status == 406) {
            toastr.error("This participant is no longer using the app. This call is not possible.");
            return;
          }

          toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the session tokens!");
        }
      );
    },
    switchScreen(vObj) {
      if (vObj.type == "thPanel") {
        this.videoChatWidth = 26;
        this.videoObj = vObj;
        this.fullScreenWidth = "thPanel";
        this.$root.$emit("switchScreen", vObj);
      } else {
        this.videoChatWidth = 100;
        this.videoObj = vObj;
        this.fullScreenWidth = "fullScreen";
        this.$root.$emit("switchScreen", vObj);
      }
    },
    getParticipantCountryId() {
      this.$api.getParticipantDataFactV2(this.callObject.studyId, this.callObject.threadID).then(
        response => {
          this.getCountrySpecificStudyFeatures(response.body.countryId);
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting participant.");
        }
      );
    },
    getVisitEligiblity() {
      this.$api.getVisitDetail(this.callObject.studyId, this.callObject.visitId).then(
        response => {
          // check if telehealth visit is allowed
          this.recordingOptions.isRecordingTrue = response.body.telehealthVisitDTO.allowRecording;
          this.createSession();
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while getting country specific telehealth status");
        }
      );
    },
    getCountrySpecificStudyFeatures(countryId) {
      this.$api.getCountrySpecificStudyFeatures(this.callObject.studyId).then(
        response => {
          const countrySpecificStudyFeatures = response.body;
          // fetch participant country
          let participantCountry = countrySpecificStudyFeatures.filter(c => {
            return c.country_id == countryId;
          });
          if (participantCountry.length == 0 || participantCountry == "undefined") {
            participantCountry = response.body;
          }
          if (this.callObject.type != undefined && this.callObject.type == "scheduled") {
            if (participantCountry[0].studyTelehealthRecordingEnabled) {
              this.recordingOptions.isRecordingTrue = true;
              this.createSession();
            }
            // if recording is allowed on visit level
            else if (participantCountry[0].visitTelehealthRecordingEnabled) {
              this.getVisitEligiblity();
            } else {
              this.createSession();
            }
          } else {
            this.recordingOptions.isRecordingTrue = participantCountry[0].studyTelehealthRecordingEnabled;
            this.createSession();
          }
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while getting country specific telehealth status");
        }
      );
    }
  }
};
</script>

<style scoped lang="scss">
#video-display-container {
  position: fixed;
  width: 26%;
  background: transparent;
  z-index: 999;
  right: 0;
  height: 100%;
  top: 0;
  display: block;
  transition: visibility 0s, opacity 0.5s linear;
  &.screen-sharing {
    height: 0;
    top: revert;
    bottom: 0;
  }
  &.hide-th-Panel {
    display: none;
    transition: visibility 0s, opacity 0.5s linear;
  }
}
#video-chat-container {
  width: 100%;
  height: 100%;
  &.screen-sharing {
    height: 0;
  }
}
.full-width {
  width: 100%;
  height: 100%;
}
</style>
